module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_11_A.e8abe4bf.mp3";